import { Redirect, Switch, useLocation } from 'react-router-dom'

import TrackedGremlinRoute from 'components/TrackedGremlinRoute'
import SignIn from 'components/authentication/SignIn'
import SignInUsingSAML from 'components/authentication/SignInUsingSAML'
import GoogleCallback from 'components/authentication/callbacks/Google'
import SAMLCallback from 'components/authentication/callbacks/SAML'
import Register from 'components/authentication/registration/register-company/Register'
import NewUser from 'components/authentication/registration/new-user/NewUser'
import RequestPasswordReset from 'components/authentication/RequestPasswordReset'
import ResetPassword from 'components/authentication/ResetPassword'
import ResetCompany from 'components/authentication/FindCompany'
import SignUp from 'components/authentication/registration/free-edition/SignUp'
import GoogleCallbackForFree from 'components/authentication/registration/free-edition/GoogleCallback'
import AccountSetup from 'components/authentication/registration/free-edition/AccountSetup'
import theme from 'theme'

const UnauthenticatedRoutes: React.FC = () => {
  const { pathname, search } = useLocation()

  return (
    <div
      css={{
        backgroundColor: theme.colors.gray[0],
        position: 'relative'
      }}
    >
      <Switch>
        <TrackedGremlinRoute
          exact
          component={SignIn}
          name="Login"
          path="/login"
        />
        <TrackedGremlinRoute
          exact
          component={SignInUsingSAML}
          name="SAML Login"
          path="/login/saml"
        />
        <TrackedGremlinRoute
          exact
          component={props => <SignUp {...props} />}
          name="Signup"
          path="/signup"
        />
        <TrackedGremlinRoute
          exact
          component={props => <GoogleCallbackForFree {...props} />}
          path="/free/google"
        />
        <TrackedGremlinRoute
          exact
          component={props => <AccountSetup {...props} />}
          name="Account Setup"
          path="/setup"
        />
        <TrackedGremlinRoute
          exact
          component={props => <GoogleCallback {...props} />}
          path="/users/sso/google/login"
        />
        <TrackedGremlinRoute
          exact
          component={props => <SAMLCallback {...props} />}
          path="/users/sso/saml/acs"
        />
        <TrackedGremlinRoute
          exact
          component={props => <RequestPasswordReset {...props} />}
          name="Password Reset"
          path="/password-reset"
        />
        <TrackedGremlinRoute
          exact
          component={props => <ResetPassword {...props} />}
          path="/users/password/update"
        />
        <TrackedGremlinRoute
          exact
          component={props => <ResetCompany {...props} />}
          path="/find/company"
        />
        <TrackedGremlinRoute
          component={props => <Register {...props} />}
          name="Register"
          path="/register"
        />
        <TrackedGremlinRoute
          component={props => <NewUser {...props} />}
          name="New User Setup"
          path="/users/new"
        />
        <Redirect
          to={{
            pathname: '/login',
            ...(pathname &&
              pathname !== '/' && {
                search: `next=${encodeURIComponent(
                  pathname + (search ? search : '')
                )}`
              })
          }}
        />
      </Switch>
    </div>
  )
}

export default UnauthenticatedRoutes
